import { MemberTypeUpdatePage } from '@/features/member-type/pages/MemberTypeUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/member-type/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["member_type.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: MemberTypeUpdatePage,
})
